<app-complex-modal-template
    [canConfirm]="true"
    [stepNumber]="1"
    [title]="'addUserAccess' | transloco"
    (onClickEvent)="onClickEvent($event)">
    @if (peopleListBloc.value()) {
        <div class="w-full my-8">
            <app-select
                [isMultiSelect]="true"
                [label]="'user' | transloco"
                [options]="peopleOptions()"
                [placeholder]="'selectUser' | transloco"
                [(selectedOptions)]="selectedPeopleOptions" />
        </div>
    }
</app-complex-modal-template>
